/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-duplicates */
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import { Avatar, Flex, Table, TableContainer, Tbody, Text, Thead, Tr } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { iReuniaoOneDashResponse } from '../../../../../interfaces'
import { OutlineTable, StyledSpan } from './styles'

interface iProps {
  reunioes: iReuniaoOneDashResponse[]
}

export const TabelaReunioes: React.FC<iProps> = ({ reunioes }) => {
  const nav = useNavigate()

  function ObterNomeStatus(status: number): string {
    switch (status.toString()) {
      case '0':
        return 'Aguardando'
      case '1':
        return 'Aceita'
      case '2':
        return 'Recusada'
      case '3':
        return 'Reagendada'
      case '4':
        return 'atrasada'
      case '5':
        return 'Finalizada'
	  case '6':
	    return 'Agendamento'
      default: return ''
    }
  }

  function ObterCorStatus(status: number): string {
    switch (status.toString()) {
      case '0':
        return 'var(--Gray3)'
      case '1':
        return 'var(--Azul)'
      case '2':
        return 'var(--Rosa)'
      case '3':
        return 'var(--Purple1)'
      case '4':
        return 'var(--Red)'
      case '5':
        return 'var(--Green3)'
	    case '6':
        return 'var(--Orange)'
      default: return ''
    }
  }

  return (
    <Flex>
      <OutlineTable>
        <TableContainer>
          <Table variant='simple'>
            <Thead>
              <Tr _hover={{ bg: 'var(--c1) !important', color: 'black' }}>
                <th>Organizador </th>
                <th>Convidado</th>
                <th>Tipo</th>
                <th>Assunto</th>
                <th>Status</th>
                <th>Data</th>
              </Tr>
            </Thead>
            <Tbody>
              {reunioes?.map(e => {
                return (
                  <Tr key={e.id} style={{ cursor: 'pointer' }} onClick={() => nav(`/Jornada/NovaReuniaoOne/Visualizar/${e.id}`)}>
                    <td>
                      <StyledSpan style={{ justifyContent: 'start', padding: '.5rem 1rem' }}>
                        <Avatar src={e.criador?.avatar} width={'2rem'} h={'2rem'} />
                        <Text color={'Gray1'} fontWeight={'600'} fontSize={'12px'}>
                          {e.criador?.nome ?? 'Não identificado'}
                        </Text>
                      </StyledSpan>
                    </td>
                    <td >
                      <StyledSpan style={{ justifyContent: 'start', paddingLeft: '1rem' }}>
                        <Avatar name={e.convidado?.nome} src={e.convidado?.avatar ?? ''} width={'2rem'} h={'2rem'} />
                        <Text color={'Gray1'} fontWeight={'600'} fontSize={'12px'}>
                          {e.convidado?.nome ?? 'Não identificado'}
                        </Text>
                      </StyledSpan>
                    </td>

                    <td>
                      <StyledSpan>
                        <Text color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>{e.tipo.nome}</Text>
                      </StyledSpan>
                    </td>
                    <td>
                      <StyledSpan>
                        <Text color={'Gray1'} fontSize={'12px'} title={e.assunto} fontWeight={'400'}>{e.assunto?.length > 12 ? e.assunto.substring(0, 12) + '...' : e.assunto}</Text>
                      </StyledSpan>
                    </td>
                    <td>
                      <StyledSpan>
                        <Text
                          borderRadius={'6px'}
                          color={'#fff'}
                          bgColor={ObterCorStatus(e.status)}
                          px={'.5rem'} h={'1.4rem'}
                          fontSize={'12px'}
                          fontWeight={'400'}
                        >
                          {ObterNomeStatus(e.status)}
                        </Text>
                      </StyledSpan>
                    </td>
                    <td>
                      <StyledSpan>
                        <Text color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>{e.dataInicio ?? 'Não definida'}</Text>
                      </StyledSpan>
                    </td>
                  </Tr>
                )
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </OutlineTable>
    </Flex>
  )
}
